export const POST_DELIVERYSTATUS_INIT_ACTION =
  "POST_DELIVERYSTATUS_INIT_ACTION";
export const POST_DELIVERYSTATUS_SUCCESS_ACTION =
  POST_DELIVERYSTATUS_INIT_ACTION + "_SUCCESS";
export const POST_DELIVERYSTATUS_FAIL_ACTION =
  POST_DELIVERYSTATUS_INIT_ACTION + "_ERROR";

export const GET_DELIVERYSTATUS_INIT_ACTION = "GET_DELIVERYSTATUS_INIT_ACTION";
export const GET_DELIVERYSTATUS_SUCCESS_ACTION = GET_DELIVERYSTATUS_INIT_ACTION + "_SUCCESS";
export const GET_DELIVERYSTATUS_FAIL_ACTION = GET_DELIVERYSTATUS_INIT_ACTION + "_FAIL";

export const DELETE_DELIVERYSTATUS_INIT_ACTION = "DELETE_DELIVERYSTATUS_INIT_ACTION";
export const DELETE_DELIVERYSTATUS_SUCCESS_ACTION = DELETE_DELIVERYSTATUS_INIT_ACTION + "_SUCCESS";
export const DELETE_DELIVERYSTATUS_FAIL_ACTION = DELETE_DELIVERYSTATUS_INIT_ACTION + "_FAIL";

export const EDIT_DELIVERYSTATUS_INIT_ACTION = "EDIT_DELIVERYSTATUS_INIT_ACTION";
export const EDIT_DELIVERYSTATUS_SUCCESS_ACTION = EDIT_DELIVERYSTATUS_INIT_ACTION + "_SUCCESS";
export const EDIT_DELIVERYSTATUS_FAIL_ACTION = EDIT_DELIVERYSTATUS_INIT_ACTION + "_FAIL";

export function postDeliverystatus(value) {
  return {
    type: POST_DELIVERYSTATUS_INIT_ACTION,
    value:value,
  };
}

export function getDeliverystatus(value){
    return {
        type:GET_DELIVERYSTATUS_INIT_ACTION,
        value:value,
    }
}

export function statuspageSelected(value){
  return {
    type:GET_DELIVERYSTATUS_INIT_ACTION,
    value:value,
  }
}

export function deleteStatus(value){
  return {
    type:DELETE_DELIVERYSTATUS_INIT_ACTION,
    value:value,
  }
}

export function editDeliverystatus(value){
  return {
    type: EDIT_DELIVERYSTATUS_INIT_ACTION,
    value:value,
  }
}
